import PlainButtonAsLink, { type Props as PlainButtonLinkProps } from './plain-button-as-link'

export default PlainButtonAsLink
export type { PlainButtonLinkProps }
